<template>
    <div class="ReportForm" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>财务报表</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="报表月份">
                                    <!-- <el-input v-model="queryform.date"></el-input> -->
                                    <el-date-picker
                                        v-model="queryform.date"
                                        type="month"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM">
                                    </el-date-picker>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-button type="primary" @click="AddReportForm">新增</el-button> -->
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="transaction_id" label="订单号" align="center">
                    </el-table-column>
                    <el-table-column prop="from" label="来源" align="center">
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" align="right">
                    </el-table-column>
                    <el-table-column prop="create_time" label="创建时间" align="center">
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <!-- <template slot-scope="scope">
                            <el-button type="text" @click="EditReportForm(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelReportForm(scope.row)">删除</el-button>
                        </template> -->
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="ReportForm" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="ReportForm">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="间禁ID" prop="UID">
                            <el-input v-model="form.UID" :disabled="true"></el-input>
                        </el-form-item>
                        <el-form-item label="间禁号" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="备注" style="display: block; width: 100%;">
                            <el-input type="textarea" v-model="form.remark"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="ReportForm = false">取 消</el-button>
                        <el-button type="primary" @click="SaveReportForm" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "ReportForm",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            ReportForm: false,
            form: {
                title: '',
                contact: '',
                tel: '',
                contact1: '',
                tel1: '',
                remark: '',
                img: [],
                intro: '',
                room: '',
                status: 1
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                date: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {},
            confirmloding: false
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetReportFormList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetReportFormList()
        },
        GetReportFormList () {
            let data = {
                iYear: this.queryform.date.split('-')[0],
                iMonth: this.queryform.date.split('-')[1],
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('ReportFormListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                console.log(res.data)
                this.tableData = res.data
                // this.form = {
                //     title: '',
                //     remark: '',
                // }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                date: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            // console.log(this.queryform)
            this.GetReportFormList()
        },
        SaveReportForm() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            // data.img = JSON.stringify(this.form.img)
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true
                    that.$store.dispatch('SaveReportForm', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.confirmloding = false
                            that.ReportForm = false
                            that.fullscreenLoading = true
                            that.GetReportFormList()
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    // that.$message({
                    //     message: '请先填写必填项',
                    //     type: 'error'
                    // })
                    return false;
                }
            });
            
        },
        EditReportForm(row) {
            this.ReportForm = true
            this.title = '编辑门禁'
            this.form = JSON.parse(JSON.stringify(row))
            // this.fileList = JSON.parse(this.form.img)
            // this.form.img = JSON.parse(this.form.img)
        },
        DelReportForm(row) {
            this.$confirm('是否删除该门禁？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelReportForm', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetReportFormList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        }
    },
    created() {
        let date = new Date()
        let Y = date.getFullYear()
        let M = date.getMonth() + 1
        if (M < 10) {
            M = '0' + M
        }
        this.queryform.date = Y + '-' + M
        this.fullscreenLoading = true
        this.GetReportFormList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.ReportForm {
    width: 100%;
}
.ReportForm .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.ReportForm .el-header .el-row .el-col h2 {
    text-align: center;
}
.ReportForm .el-header .el-row .el-col {
    text-align: center;
}
.ReportForm .el-header .el-row .el-col:last-child {
    text-align: right;
}
.ReportForm .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.ReportForm .el-main .ReportForm .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
/* .ReportForm .el-main .ReportForm .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
} */
</style>
